import { useEffect } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";

export default function LegendControl() {
  const map = useMap();
  const legend = L.control as any;

  useEffect(() => {
    if (!map) return;

    const myLegend = legend({ position: "bottomright" });

    myLegend.onAdd = function () {
      const div = L.DomUtil.create("div", "leaflet-legend");
      div.innerHTML = `
        <div class="legend-box">
          <h4>Leyenda</h4>
          <div class="legend-item">
            <span class="legend-color" style="background:#964594;"></span>
            Municipios del Bosque Modelo Palencia
          </div>
        </div>
      `;
      return div;
    };

    myLegend.addTo(map);

    return () => {
      myLegend.remove();
    };
  }, [map]);

  return null;
}
